// extracted by mini-css-extract-plugin
export default {"Input__Input":"Input_Input__Input__QRFUD","Input__Label":"Input_Input__Label__b4dRr"};